import React, { useState, useEffect } from "react";
import "../../styles/App.css";

const AboutPage = () => {
  return (
    <div className="page-container">
      <p>
        Система призначена для трьох основних типів користувачів: декан,
        відповідальна особа від студентів та адміністратор бази даних.
      </p>
      <p>Кожен тип має власні рівні доступу та функціональні можливості.</p>
      <p>
        Для відповідальної особи від студентів вхід до системи відбувається за
        допомогою спеціальної сторінка та з використанням Google профілю.
        Відповідальна особа має можливість запропонувати документ про акт та
        вибрати потрібного студента. При створенні акту користувач може
        прикріпити файл, який автоматично завантажується на Google Drive.
        Документ має бути оформлений відповідним чином.
      </p>
      <p>
        Для декана або адміністратора після успішного входу видно інтерактивну
        мапу гуртожитку. Оберіть потрібний Вам поверх. Кожна кімната
        відображається у вигляді мітки, колір якого залежить від її статусу.
        Якщо кімната немає порушників - вона зеленого кольору. Якщо в кімнаті
        мало кількість порушень, тоді вона жовта. Якщо кількість порушень
        перевищує 3, тоді буде офарбована в червоний колір. Також, є сірий стан
        кімнати, який означає, що кімната неактивна (пуста) або недоступна для
        студентів. Якщо натиснути на кімнату з’явиться модальне вікно кімнати,
        де є можливість переходу на студента та перегляд детальної інформації
        про кімнату.
      </p>
      <p>
        Сторінка «Інші гуртожитки» надає користувачу доступ до таблиці студентів
        з можливістю фільтрації за гуртожитками, групами та рейтинговими
        показниками. Інформація представлена у форматі таблиці, де кожен рядок
        відповідає окремому студенту і дозволяє перейти до його розгорнутого
        профілю.
      </p>
      <p>
        У профілі студента відображається повна інформація про його поселення,
        історію переселень, поточний рейтинг, отримані акти або заохочень, а
        також прикріплені документи. Інтерфейс також підтримує редагування
        персональних даних студента у разі потреби.
      </p>
      <p>Для керування поселенням реалізовано три основні форм.</p>
      <p>
        Перша, форма поселення, яка дозволяє зареєструвати нового студента в
        системі, внести дані про його прізвище, ім’я, групу, пільговий статус та
        іншу супровідну інформацію. Після цього користувач обирає доступну
        кімнату в гуртожитку, і система надсилає всі введені дані на сервер для
        збереження.
      </p>
      <p>
        Друга форма відповідає за переселення студентів. Вона відображає поточну
        кімнату мешканця та дозволяє обрати іншу доступну кімнату або залишити
        студента на місці, оновивши запис у базі.
      </p>
      <p>
        Третя форма використовується для виселення. Після підтвердження студент
        переноситься до архіву, де зберігається його історія проживання. За
        потреби передбачена можливість повторного повернення з архіву до
        активного списку, однак така дія може бути обмежена під час виселення за
        окремими умовами.
      </p>
      <p>
        Система підтримує автоматизоване формування звітів для адміністративних
        потреб. Користувачі можуть фільтрувати звітні дані за прізвищем
        студента, датою події, описом або наявністю прикріпленого документа, а
        також експортувати результати у формат Excel для подальшого аналізу чи
        подання керівництву. Звіти охоплюють як інформацію про кількість і тип
        порушень за вибраний період, так і рейтинги студентів по групах з
        можливістю оцінити кількість заохочень та дисциплінарних заходів.
      </p>
      <p>
        Модуль рейтингу надає повний функціонал для додавання, перегляду та
        фільтрації балів кожного студента, а також підтримує експорт результатів
        у файл.
      </p>
      <p>
        Додаткові модулі, зокрема «Керування актами», «Керування кімнатами» та
        «Керування гуртожитками», доступні виключно для користувачів із роллю
        адміністратора бази даних, оскільки вони мають прямий доступ до
        системних таблиць.
      </p>
      <p>
        Через модуль гуртожитків можна створювати нові об'єкти, редагувати або
        видаляти існуючі, а також вносити зміну у їх адреси та кількість
        поверхів.
      </p>
      <p>
        Модуль управління кімнатами дозволяє додавати нові приміщення,
        редагувати опис, зазначати кількість ліжок і здійснювати контроль за
        розміщенням.
      </p>
      <p>
        Модуль керування актами відкриває доступ до повного списку поданих актів
        із функцією фільтрації за типом документа, датою або студентом, а також
        дозволяє переглядати супровідні файли, редагувати або видаляти вже
        внесені записи.
      </p>
      <p>
        Отже, система побудована інтуїтивно та доступно для користувачів з
        різним рівнем технічної підготовки. Чітке розділення ролей та
        інтерактивний інтерфейс забезпечують легке навчання персоналу та швидке
        впровадження у реальну роботу.
      </p>
    </div>
  );
};

export default AboutPage;
